import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

import { EmployeeForm } from '../../../constants/constant_form_names';
import {
  INTEGRATION,
  CONTACT,
  CUSTOMER,
  EMPLOYEE,
} from '../../../constants/constant_entity_types';
import { getEntityType } from '../../../common/selectors/selector_common';

const selector = formValueSelector(EmployeeForm);

const getPreferenceSetting = state => state.preference.settings;
const getFormCustomTabs = state => selector(state, 'custom_tabs') || [];
const getFormEntityTypeIds = (state) => selector(state, 'entity_type_ids') || [];

export const isEmployee = createSelector(
  [getFormEntityTypeIds, getEntityType],
  (entityTypeIds, entityTypes) => {
    const { id: employeeId } = entityTypes.find(({ cid }) => EMPLOYEE === cid);
    return entityTypeIds.indexOf(employeeId) > -1;
  },
);

export const getCustomTabs = createSelector(
  [getFormCustomTabs],
  customTabs => customTabs,
);

export const getLegalAge = createSelector(
  [getPreferenceSetting],
  (preference) => {
    return preference['legal_age'];
  },
);

export const isFirstLastNameRequired = createSelector(
  [getPreferenceSetting],
  (preference) => {
    return preference['entity_first_last_name_required'];
  },
);

export const getExcludedEntityTypes = createSelector(
  [getPreferenceSetting, getEntityType, getFormEntityTypeIds],
  (preference, types, ids) => {
    const excludedEntityTypes = [INTEGRATION, CONTACT];
    const enableEmployeeAsCustomer = preference['enable_employee_as_customer'];
    if (!enableEmployeeAsCustomer) {
      const { id: customerId } = types.find(({ cid }) => CUSTOMER === cid);

      if (ids.indexOf(customerId) === -1) {
        excludedEntityTypes.push(CUSTOMER);
      }
    }

    return excludedEntityTypes;
  },
);

